export default __webpack_public_path__ + "static/media/ecosense-white.16418269.png";